import React, { useState } from "react";
import PropTypes from "prop-types";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftSelect from "components/SoftSelect";
import Grid from "@mui/material/Grid";

function MonthYearFilter({ onFilterChange }) {
  const currentYear = new Date().getFullYear();

  const years = Array.from({ length: 25 }, (_, i) => {
    const year = currentYear - i;
    return { value: year, label: year.toString() };
  });

  const months = [
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" },
  ];

  const [selectedYear, setSelectedYear] = useState(years[0]);
  const [selectedMonth, setSelectedMonth] = useState(months[new Date().getMonth()]);

  const handleYearChange = (value) => {
    setSelectedYear(value);
    onFilterChange({ year: value.value, month: selectedMonth.value });
  };

  const handleMonthChange = (value) => {
    setSelectedMonth(value);
    onFilterChange({ year: selectedYear.value, month: value.value });
  };

  return (
    <SoftBox p={1}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <SoftTypography variant="caption" fontWeight="bold" color="text">
            Select Year
          </SoftTypography>
          <SoftSelect
            placeholder="Select Year"
            options={years}
            value={selectedYear}
            onChange={handleYearChange}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <SoftTypography variant="caption" fontWeight="bold" color="text">
            Select Month
          </SoftTypography>
          <SoftSelect
            placeholder="Select Month"
            options={months}
            value={selectedMonth}
            onChange={handleMonthChange}
          />
        </Grid>
      </Grid>
    </SoftBox>
  );
}

MonthYearFilter.propTypes = {
  onFilterChange: PropTypes.func.isRequired,
};

export default MonthYearFilter;
